import { render, staticRenderFns } from "./SoliDate.vue?vue&type=template&id=f0a7dd0c"
import script from "./SoliDate.vue?vue&type=script&lang=js"
export * from "./SoliDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports